export const STATUS_CONFIG = {
  processing      : { label:'Processing',        cls:'gray'   },
  enriching       : { label:'Enriching',         cls:'gray'   },
  nbi_ready       : { label:'NBI Ready',         cls:'green'  },
  data_incomplete : { label:'Data Incomplete',   cls:'amber'  },
  nbi_sent        : { label:'NBI Sent',          cls:'blue'   },
  assessment_sent : { label:'Assessment Sent',   cls:'amber'  },
  in_progress     : { label:'In Progress',       cls:'amber'  },
  ready_to_quote  : { label:'Ready to Quote',    cls:'green'  },
  review_incomplete: { label:'Review Incomplete', cls:'amber' },
  quote_sent      : { label:'Quote Sent',        cls:'purple' },
  ready_to_bind   : { label:'Ready to Bind',     cls:'green'  },
  policy_issuance : { label:'Policy Issuance',   cls:'green'  },
  appetite_decline: { label:'Appetite Decline',  cls:'red'    },
  referred        : { label:'Referred',          cls:'amber'  },
  declined        : { label:'Declined',          cls:'red'    },
  not_taken       : { label:'Not Taken',         cls:'gray'   },
  cancelled       : { label:'Cancelled',         cls:'gray'   },
};

export const OPEN_STATUSES = [
  'processing','enriching','nbi_ready','data_incomplete','nbi_sent',
  'assessment_sent','in_progress','ready_to_quote','review_incomplete',
  'quote_sent','ready_to_bind','referred',
];

export const CLOSED_STATUSES = [
  'policy_issuance','appetite_decline','declined','not_taken','cancelled',
];

export const CLS_STYLES = {
  green : { bg:'var(--green-bg)',   color:'var(--green)',  border:'var(--green-b)'  },
  amber : { bg:'var(--amber-bg)',   color:'var(--amber)',  border:'var(--amber-b)'  },
  red   : { bg:'var(--red-bg)',     color:'var(--red)',    border:'var(--red-b)'    },
  blue  : { bg:'var(--blue-bg)',    color:'var(--accent)', border:'var(--blue-b)'   },
  purple: { bg:'var(--purple-bg)',  color:'var(--purple)', border:'var(--purple-b)' },
  gray  : { bg:'#141820',          color:'var(--muted2)', border:'var(--border)'   },
};

export const GRADES = [
  { min:85, label:'Excellent', color:'var(--green)'  },
  { min:65, label:'Good',      color:'#7dd3fc'       },
  { min:50, label:'Standard',  color:'var(--amber)'  },
  { min:0,  label:'Poor',      color:'var(--red)'    },
];

export const VALID_TRANSITIONS = {
  processing      : ['enriching', 'appetite_decline', 'referred', 'cancelled'],
  enriching       : ['nbi_ready', 'data_incomplete', 'appetite_decline', 'referred', 'cancelled'],
  nbi_ready       : ['nbi_sent', 'referred', 'declined', 'cancelled'],
  data_incomplete : ['assessment_sent', 'nbi_ready', 'referred', 'declined', 'cancelled'],
  nbi_sent        : ['assessment_sent', 'not_taken', 'referred', 'declined', 'cancelled'],
  assessment_sent : ['in_progress', 'cancelled'],
  in_progress     : ['ready_to_quote', 'review_incomplete', 'cancelled'],
  ready_to_quote  : ['quote_sent', 'in_progress', 'referred', 'declined'],
  review_incomplete: ['in_progress', 'ready_to_quote', 'referred', 'declined'],
  quote_sent      : ['ready_to_bind', 'not_taken', 'declined'],
  ready_to_bind   : ['policy_issuance', 'not_taken'],
  policy_issuance : [],
  appetite_decline: [],
  referred        : ['nbi_ready', 'data_incomplete', 'declined'],
  declined        : [],
  not_taken       : [],
  cancelled       : [],
};

export const REQUIRED_FOR_SCORE = [
  'construction_type','sprinkler_system','occupancy_class','tiv','state',
];

export function getStatus(status) {
  return STATUS_CONFIG[status] || { label: status, cls:'gray' };
}

export function canTransition(from, to) {
  return (VALID_TRANSITIONS[from] || []).includes(to);
}

export function isClosed(sub) {
  return CLOSED_STATUSES.includes(sub?.status);
}

export function isDeclined(sub) {
  return ['appetite_decline','declined'].includes(sub?.status);
}

export function getGrade(score) {
  if (score == null) return { label:'—', color:'var(--muted)' };
  return GRADES.find(g => score >= g.min) || { label:'Poor', color:'var(--red)' };
}

export function getField(sub, name) {
  return sub.fields?.find(f => f.field_name === name)?.field_value || null;
}

export function allFieldsPresent(sub) {
  const fm = {};
  (sub.fields || []).forEach(f => { fm[f.field_name] = f; });
  if ((sub.fields || []).length === 0) return false;
  return REQUIRED_FOR_SCORE.every(n => {
    const f = fm[n];
    return f && f.field_value && f.confidence !== 'missing' && f.confidence !== 'low';
  });
}

export function missingFields(sub) {
  const fm = {};
  (sub.fields || []).forEach(f => { fm[f.field_name] = f; });
  return REQUIRED_FOR_SCORE.filter(n => {
    const f = fm[n];
    return !f || !f.field_value || f.confidence === 'missing' || f.confidence === 'low';
  });
}

export function fmtM(n) {
  if (!n || isNaN(n)) return '—';
  const num = parseFloat(n);
  if (num >= 1e6) return '$' + (num / 1e6).toFixed(2) + 'M';
  if (num >= 1000) return '$' + (num / 1000).toFixed(0) + 'K';
  return '$' + num;
}

export function receivedStr(d) {
  if (!d) return '—';
  const date = new Date(d);
  const mon  = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'][date.getMonth()];
  const day  = date.getDate();
  const diffH = Math.floor((Date.now() - date) / 3600000);
  const diffD = Math.floor(diffH / 24);
  const elapsed = diffD > 0 ? diffD + 'd' : diffH + 'h';
  return `${mon} ${day} · ${elapsed}`;
}
